import React from 'react';
import LazyLoad from 'react-lazyload';
import { useStyles } from './styles';
import { Box, Container, Typography } from '@mui/material';
import Image from 'next/image';
import CustomButton from 'components/CustomButton';
import NextLink from 'next/link';

export default function BookDemo() {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Box bgcolor="#EEEEEE" pt={4} pb={8}>
        <Container>
          <Box className={classes.mainContentBox} py={6}>
            <Box pb={8}>
              <Typography
                className={classes.primaryColor}
                variant="h4"
                component="h2"
                align="center"
              >
                <b>Book a demo for your institution</b>
              </Typography>
            </Box>

            <Box className={classes.mainFeaturesBox}>
              <Box textAlign="center">
                <Image
                  src="/images/user-friendly-icon.png"
                  alt="user friendly icon"
                  loading="lazy"
                  width={54}
                  height={54}
                />

                <Typography className={classes.titleFeatures}>User-friendly Interface</Typography>

                <Typography>
                  Easy to understand and <br /> even easier to use.
                </Typography>
              </Box>

              <Box textAlign="center">
                <Image
                  src="/images/star-black-icon.png"
                  alt="star icon"
                  loading="lazy"
                  width={67}
                  height={59}
                />

                <Typography className={classes.titleFeatures}>Priority Chat Support</Typography>

                <Typography>
                  In case you need help, reach
                  <br /> out to our online priority <br />
                  chat support.
                </Typography>
              </Box>

              <Box textAlign="center">
                <Image
                  src="/images/online-platform-icon.webp"
                  alt="online platform icon"
                  loading="lazy"
                  width={67}
                  height={64}
                />

                <Typography className={classes.titleFeatures}>Online platform</Typography>

                <Typography>
                  Access creations at any <br /> time and from anywhere.
                </Typography>
              </Box>

              <Box textAlign="center">
                <Image
                  src="/images/pre-made-resources-black-icon.png"
                  alt="pre made resources icon"
                  loading="lazy"
                  width={72}
                  height={71}
                />

                <Typography className={classes.titleFeatures}>Pre-made Resources</Typography>

                <Typography>
                  Start editing one of our <br /> templates. Just customize <br /> colors, text and
                  more.
                </Typography>
              </Box>
            </Box>

            <Box className={classes.mainFeaturesBox} pt={10}>
              <Box textAlign="center">
                <Image
                  src="/images/on-demand-illustration-black-icon.png"
                  alt="on demand icon"
                  loading="lazy"
                  width={62}
                  height={76}
                />

                <Typography className={classes.titleFeatures}>On-demand illustrations</Typography>

                <Typography>
                  Couldn't find what you need? <br /> We will design it for you.
                </Typography>
              </Box>

              <Box textAlign="center">
                <Image
                  src="/images/drag-drop-icon.webp"
                  alt="drag drop icon"
                  loading="lazy"
                  width={65}
                  height={71}
                />

                <Typography className={classes.titleFeatures}>Drag and Drop</Typography>

                <Typography>
                  Easily select and manage <br /> illustrations, text and <br />
                  templates.
                </Typography>
              </Box>

              <Box textAlign="center">
                <Image
                  src="/images/digital-illustration-black-icon.png"
                  alt="digital illustration icon"
                  loading="lazy"
                  width={75}
                  height={75}
                />

                <Typography className={classes.titleFeatures}>
                  Scientifically-accurate <br /> illustrations
                </Typography>

                <Typography>
                  Represent science concepts <br /> graphically with maximum <br /> accuracy.
                </Typography>
              </Box>
            </Box>

            <Box display="flex" justifyContent="center" pt={6}>
              <NextLink href={`/institutions/book-a-demo`} passHref={true}>
                <CustomButton>Book a Demo</CustomButton>
              </NextLink>
            </Box>
          </Box>
        </Container>
      </Box>
    </LazyLoad>
  );
}
